export const endorsementIssues = Object.freeze(
  /** @type {const} */ ({
    MISSING_POLICY: 'Missing On New Policy',
    UNSUPPORTED_LINE_OF_BUSINESS: 'Unsupported Line of Business Detected',
    MISSING_LINE_OF_BUSINESS: 'Required Line of Business Missing',
    MISSING_COVERAGE: 'Required Coverage Missing',
    NO_COVERAGE: 'No Coverage Exists On New Line of Business',
  })
);
